import uniq from 'lodash/uniq';
import type { RegisterOptions } from 'react-hook-form';

import { validateIpAddresses } from '@packages/utils/validate-ip-addresses/validate-ip-addresses';

export const ipRangeConfig: RegisterOptions = {
  required: {
    value: true,
    message: 'IP Address Range is required',
  },
  validate: (ip: string) =>
    validateIpAddresses([ip.trim()]).valid.size === 1 || 'Invalid IP Address',
};

export const PORT_REGEX =
  /^(\d{1,5})(-(\d{1,5}))?(,\s?(\d{1,5})(-(\d{1,5}))?)*$/;

export const portsConfig: RegisterOptions = {
  pattern: {
    value: PORT_REGEX,
    message: 'Invalid Port',
  },
  validate: (ports: string) => {
    const portList = ports?.split(/,\s*/) || [ports];
    return uniq(portList).length === portList.length || 'Duplicate Ports';
  },
  min: {
    value: 1,
    message: 'Port must be at least 1',
  },
  max: {
    value: 65535,
    message: 'Port must not exceed 65535',
  },
  maxLength: {
    value: 2000,
    message: "Length of field can't exceed 2000 characters",
  },
};
